+ (($) ->
  'use strict'
  ### global Modernizr ###
  ### global Response ###

  Quiz =
    init: ->
      @markIndex()
      @setupFirst()
      @quizAction()
      @reset()
      shareBtn = $('#social-share-area').find('.share-btn')
      $currentUrl = window.location.hostname + window.location.pathname
      @btnShareAction(shareBtn, $currentUrl)

    markIndex: ->
      $.each $('.quiz-question-form'), ( index, value ) -> 
        $(@).find('.quiz-number')
        .text(index + 1 + '.')
      

    setupFirst: ->
      $('.radio-button-block').each ->
        $correct = Number($(@).attr 'data-correct')
        if $correct is 0
          $(@).addClass 'error-button'
        else          
          $(@).addClass 'right-button'

    quizAction: ->
      $('.radio-button-block').each ->
        $score = Number($(@).attr 'data-score')
        $result = $(@).attr 'data-result'


        $(@).on 'click', ->
          $(@).addClass 'disabled'
          parentsDiv = $(@).parents('.quiz-question-form')
          $resultDiv = parentsDiv.find('.quiz-question-text')
          otherBtn = parentsDiv.find('button').not($(@))
          otherRightBtn = otherBtn.hasClass 'right-button'

          # if $(@).hasClass 'active'
          $resultDiv.html($result)
          .attr 'data-sub-score', $score
          otherBtn.addClass 'disabled'
            
          if $(@).hasClass 'right-button'
            $(@).addClass 'right-button-select'
          else
            $(@).removeClass 'right-button-select'
            .addClass 'error-button-select'

          totleScore = 0
          $('.quiz-question-text').each (index, value) ->
            totleScore += Number($(@).attr 'data-sub-score')

          $('#total-score').text totleScore
          parentsDiv.addClass 'done'


          QuestionsHasDone = $('.done')
          allQuestions = $('.quiz-question-form').length
          if QuestionsHasDone.length is allQuestions

            elm = $('#quiz-final-result')
            delayTime = 300
            durationTime = 1500
            Quiz.elementDisplay(elm, delayTime, durationTime)

 
            elm = $('#quiz-question-score')
            delayTime = 600
            durationTime = 1500
            Quiz.elementDisplay(elm, delayTime, durationTime)

            elm = $('#social-share-area')
            delayTime = 1500
            durationTime = 1500
            Quiz.elementDisplay(elm, delayTime, durationTime)



    reset: ->
      $('#redo-quiz').on 'click', ->
        $('.quiz-question-text').attr 'data-sub-score', 0
        $('#total-score').text 0
        $('.radio-button-block').attr 'class', -> 
          return 'btn btn-primary radio-button-block btn-lg btn-block'
        Quiz.setupFirst()


        $('.quiz-question-text').text ''
        # $('#quiz-question-score')
        $('#quiz-final-result').fadeOut()
        $('.quiz-question-form').removeClass 'done'

        offsetPosition = $('#review-article-wrapper').position().top
        $('html').velocity('scroll', { offset: offsetPosition, mobileHA: false })



        # $.each SUB_SCORE, ( index, value ) ->
        #   console.log( index + ": " + value )

    elementDisplay: (elm, delayTime, durationTime) ->
      elm.velocity
        properties:
          translateY: 10
          # scale: 1.1
          opacity: 1
        options:
          display: 'block'
          delay: delayTime
          duration: durationTime
          # easing: Homepage.meta.easingInValue
          complete: ->
            # txt.velocity
            #   # scale: 1.01
            #   translateY: 50
            # , 2500

      
    btnShareAction: (shareBtn, $currentUrl) ->
      shareBtn.click ->       
        shareUrl = 
          if $(@).hasClass('share-to-facebook')
            'https://www.facebook.com/sharer/sharer.php?u=http%3A%2F%2F' + $currentUrl
          else if $(@).hasClass('share-to-twitter')
            'https://twitter.com/home?status=http%3A//' + $currentUrl
          else if $(@).hasClass('shenyun-glyphs-pinterest')
            'https://pinterest.com/pin/create/button/?url=http%3A//' + $currentUrl
          else if $(@).hasClass('share-to-googleplus')
            'https://plus.google.com/share?url=http%3A//' + $currentUrl

        window.open(shareUrl,'myWindow','width=560,height=392')

 


  Quiz.init()

)(jQuery)

